import React from 'react';
import PropTypes from 'prop-types';
import { PipelineStep } from './';

class PipelineStage extends React.Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    stage : PropTypes.object,
  }
  render() {
    const { stage, job, client } = this.props;

    if(!stage || !stage.steps || job.milestone != stage.name) {
      return <noscript />
    }
    return <div className="pipeline-stage animated fadeInTop">
      <ul className="list-unstyled">
        {stage.steps.map((step, index) => <li key={index}><PipelineStep step={step} job={job} client={client} /></li>)}
      </ul>
    </div>
  }
}

export default PipelineStage;



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-stage.js